module.exports = __webpack_public_path__ + "img/ColEng.0dfef11f.png";